
import axios from "axios";
const crypto = require('crypto');
const config = require('config.json');

function iterate_object(o) {
    var results = [];
    var keys = Object.keys(o);
    for (var i = 0; i < keys.length; i++) {
        results.push(o[keys[i]]);
    }
    return results;
}

export const getAPIToken = () => {
    return new Promise((resolve, reject) => {
        let username = 'GaiaApi';
        let password = 'GaiaApi%6t'
        try {
            let passwordFields = password.split('$');
            let salt = passwordFields[0];
            let hashPassword = crypto.createHmac('sha512', salt).update(password).digest("base64");
            axios.post(config.GaiaAPIUrl + '/auth', { name: username, password: hashPassword })
                .then(response => {
                    resolve(response.data.accessToken);
                }).catch(error => {
                    reject(error);
                })
        } catch (error) {
            reject(error);
        }
    });
}

export const getGuilds = (token) => {
    return new Promise((resolve, reject) => {
        try {
            var guilds;
            try {
                var guildsUpdateDate = localStorage.getItem("guildsUpdateDate")
                if (guildsUpdateDate) {
                    var updatedDate = Date.parse(localStorage.getItem("guildsUpdateDate"))

                    var DateCheckTime = 10 * 60 * 1000; // 10 minutes
                    // If we are within the time limit then use the cache
                    if (updatedDate >= new Date() - DateCheckTime) {
                        let loggedInGuilds = localStorage.getItem("guilds");
                        if (loggedInGuilds) {
                            guilds = JSON.parse(loggedInGuilds);
                            resolve(guilds);
                        }
                    }
                }
            }
            catch (error) {
                // broken, go get guilds
            }

            if (!guilds) {

                const instance = axios.create({
                    baseURL: config.GaiaAPIUrl,
                    headers: { 'Authorization': 'Bearer ' + token }
                });

                instance.get('/guilds')
                    .then(response => {
                        let guilds = iterate_object(response.data);
                        localStorage.setItem('guilds', JSON.stringify(guilds));
                        localStorage.setItem('guildsUpdateDate', new Date());
                        resolve(guilds);
                    }).catch(error => {
                        reject(error);
                    })
            }
        } catch (err) {
            reject(err);
        }
    });
}

export const getMembersForGuild = (token, guild) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            instance.get('/members/guild/' + guild)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const getMember = (token, guild, name) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            instance.get('/members/find/' + guild + '/' + name)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const getAllMembers = (token) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            instance.get('/members/')
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const getMembersWithDiscord = (token, discordtag) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            instance.get('/members/discord', { params: { discord: discordtag } })
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const createMember = (token, member, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            member.updaterdiscord = updaterDiscord;

            instance.put('/members', member)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const updateMember = (token, member, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            member.updaterdiscord = updaterDiscord;

            instance.patch('/members', member)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const updateMembers = (token, members, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            let details = {
                updaterdiscord: updaterDiscord,
                members: members
            };

            instance.patch('/members/all', details)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const updateMemberGuild = (token, guild, name, newGuild, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            let details = {
                updaterdiscord: updaterDiscord,
                newGuild: newGuild
            };

            instance.patch('/members/guild/' + guild + '/' + name, details)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const renameMember = (token, guild, name, newName, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            let details = {
                updaterdiscord: updaterDiscord,
                newName: newName
            };

            instance.patch('/members/rename/' + guild + '/' + name, details)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const updateGuild = (token, guild, lastSE, lastAce, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            let details = {
                updaterdiscord: updaterDiscord,
                lastSEPos: lastSE,
                lastAcePos : lastAce
            };

            instance.patch('/guilds/' + guild, details)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}

export const sortSheet = (token, updaterDiscord) => {
    return new Promise((resolve, reject) => {
        try {
            const instance = axios.create({
                baseURL: config.GaiaAPIUrl,
                headers: { 'Authorization': 'Bearer ' + token }
            });

            let details = {
                updaterdiscord: updaterDiscord
            };

            instance.post('/members/sort', details)
                .then(response => {
                    let members = iterate_object(response.data);
                    resolve(members);
                }).catch(error => {
                    reject(error);
                })
        } catch (err) {
            reject(err);
        }
    });
}